import { STRING_getInstance2ou4lro9xn2qn as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  Companion_getInstance3vjikuur3h0k4 as Companion_getInstance,
  Instant3cn81rq2kpflk as Instant,
} from '../Instant.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var InstantIso8601SerializerClass;
function InstantIso8601Serializer() {
  if (InstantIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        InstantIso8601Serializer_instance = this;
        this.h25_1 = PrimitiveSerialDescriptor('kotlinx.datetime.Instant', STRING_getInstance());
      }
      az() {
        return this.h25_1;
      }
      pz(decoder) {
        return Companion_getInstance().i25(decoder.h13());
      }
      j25(encoder, value) {
        encoder.p14(value.toString());
      }
      oz(encoder, value) {
        return this.j25(encoder, value instanceof Instant() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'InstantIso8601Serializer', VOID, VOID, [KSerializer()]);
    InstantIso8601SerializerClass = $;
  }
  return InstantIso8601SerializerClass;
}
var InstantIso8601Serializer_instance;
function InstantIso8601Serializer_getInstance() {
  if (InstantIso8601Serializer_instance === VOID)
    new (InstantIso8601Serializer())();
  return InstantIso8601Serializer_instance;
}
//region block: exports
export {
  InstantIso8601Serializer_getInstance as InstantIso8601Serializer_getInstance2sfqqbic5n1oz,
};
//endregion

//# sourceMappingURL=InstantSerializers.mjs.map
